// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1JnHm","row":"styles_row__2JLPl"};